<adf-datatable #dataTable smtCustomList [display]="display" [loading]="isLoading" [allowFiltering]="allowFiltering"
  [selectionMode]="selectionMode" [stickyHeader]="stickyHeader" [multiselect]="multiselect" [data]="data"
  [showHeader]="showHeader" [showMainDatatableActions]="showMainDatatableActions" [actions]="false"
  [rowMenuCacheEnabled]="true" (rowDblClick)="onRowDbClick($any($event).value?.node)"
  (row-select)="onNodeSelect($any($event).detail)" (row-unselect)="onNodeUnselect($any($event).detail)"
  (sorting-changed)="onSortingChanged($any($event))" (showRowActionsMenu)="onShowRowActionsMenu($event)"
  (executeRowAction)="onExecuteRowAction($event)" (columnOrderChanged)="onColumnOrderChanged($event)">

  <adf-no-content-template>
    <ng-template>
      <adf-empty-list *ngIf="!customNoContentTemplate">
        <div class="adf-empty-list_template adf-empty-folder">
          <div class="adf-empty-folder-this-space-is-empty">{{'ADF-DOCUMENT-LIST.EMPTY.HEADER' | translate}}</div>
          <div fxHide.lt-md="true" class="adf-empty-folder-drag-drop">{{ 'ADF-DATATABLE.EMPTY.DRAG-AND-DROP.TITLE' |
            translate }}</div>
          <div fxHide.lt-md="true" class="adf-empty-folder-any-files-here-to-add">{{
            'ADF-DATATABLE.EMPTY.DRAG-AND-DROP.SUBTITLE' | translate }}</div>
          <img [alt]="'ADF-DATATABLE.EMPTY.DRAG-AND-DROP.TITLE' | translate" class="adf-empty-folder-image"
            [src]="emptyFolderImageUrl">
        </div>
      </adf-empty-list>
      <ng-content select="adf-custom-empty-content-template, empty-folder-content"></ng-content>
    </ng-template>
  </adf-no-content-template>

  <adf-no-permission-template>
    <ng-template>
      <div class="adf-no-permission__template" *ngIf="!customNoPermissionsTemplate">
        <mat-icon>error</mat-icon>
        <p class="adf-no-permission__template--text">{{ 'ADF-DOCUMENT-LIST.NO_PERMISSION' | translate }}</p>
      </div>
      <ng-content select="adf-custom-no-permission-template, no-permission-content"></ng-content>
    </ng-template>
  </adf-no-permission-template>

  <adf-loading-content-template>
    <ng-template>
      <div class="adf-document-list-loading-container" *ngIf="!customLoadingContent">
        <mat-progress-spinner id="adf-document-list-loading" class="adf-document-list-loading-margin"
          [color]="'primary'" [mode]="'indeterminate'">
        </mat-progress-spinner>
      </div>
      <ng-content select="adf-custom-loading-content-template"></ng-content>
    </ng-template>
  </adf-loading-content-template>

  <adf-main-menu-datatable-template>
    <ng-template let-mainMenuTrigger>
      <adf-datatable-column-selector [columns]="data.getColumns()" [mainMenuTrigger]="mainMenuTrigger"
        (submitColumnsVisibility)="onColumnsVisibilityChange($event)">
      </adf-datatable-column-selector>
    </ng-template>
  </adf-main-menu-datatable-template>

  <data-columns>
    <ng-container *ngFor="let column of columns; let i = index">
      <ng-container *ngIf="!column.template; else template">
        <data-column [id]="column.id" [key]="column.key" [sortingKey]="column.sortingKey || column.key" [title]="column.title"
          [format]="column.format" [class]="column.cssClass" [sortable]="column.sortable" [isHidden]="column.isHidden"
          [draggable]="column.draggable" [type]="column.type" [customData]="column.customData">
          <ng-template let-context="$implicit">
            <ng-container *ngIf="!column.preview">
              <ng-container *ngIf="context.data.getValue(context.row, context.col) as value; else notValue">
                <ng-container
                  *ngIf="(value | columnValue : column : dataListsElementsString : context : locale) | async as columnValue; else loading">
                  <span *ngIf="column.type !== 'image'" [ngClass]="getClass(context)" [matTooltip]="columnValue.value !== columnValue.tooltip ? columnValue.tooltip : ''"
                    matTooltipClass="tooltip-html">
                    {{ columnValue.value }}
                  </span>
                  <img *ngIf="column.type === 'image'" src="{{ value }}" [matTooltip]="columnValue.tooltip | translate"
                    matTooltipClass="tooltip-html">
                  <aca-locked-by *ngIf="i == 0 && context.row.obj.entry.isLocked" [node]="context.row.obj"></aca-locked-by>
                </ng-container>
              </ng-container>
              <ng-template #notValue>
                <ng-container
                  *ngIf="(context.data.getValue(context.row, context.col) | columnValue : column : null : context : locale) | async as columnValue; else loading">
                  <span [ngClass]="getClass(context)" [matTooltip]="columnValue.value !== columnValue.tooltip ? columnValue.tooltip : ''" matTooltipClass="tooltip-html">
                    {{ columnValue.value }}
                  </span>
                  <aca-locked-by *ngIf="i == 0 && context.row.obj.entry.isLocked" [node]="context.row.obj"></aca-locked-by>
                </ng-container>
              </ng-template>
            </ng-container>
            <ng-container *ngIf="column.preview">
              <ng-container *ngIf="context.data.getValue(context.row, context.col) as value">
                <ng-container
                  *ngIf="(value | columnValue : column : dataListsElementsString : null : locale) | async as columnValue; else loading">
                  <span *ngIf="column.type !== 'image'" [ngClass]="'tooltip ' + getClass(context)" appTooltip [contextData]="context"
                    [tooltipData]="((context.row.id | rendition) | async)">
                    {{ columnValue.value }}
                  </span>
                  <img *ngIf="column.type === 'image'" src="{{ value }}" class="tooltip" appTooltip
                    [contextData]="context" [tooltipData]="((context.row.id | rendition) | async)">
                  <aca-locked-by *ngIf="i == 0 && context.row.obj.entry.isLocked" [node]="context.row.obj"></aca-locked-by>
                </ng-container>
              </ng-container>
            </ng-container>
            <ng-template #loading>
              <mat-progress-bar color="primary" mode="indeterminate"> </mat-progress-bar>
            </ng-template>
          </ng-template>
        </data-column>
      </ng-container>
      <ng-template #template>
        <data-column [id]="column.id" [key]="column.key" [title]="column.title" [type]="column.type" [format]="column.format"
          [sortable]="column.sortable" [sortingKey]="column.sortingKey || column.key" [customData]="column.customData">
          <ng-template let-context>
            <adf-dynamic-column [id]="column.template" [context]="context" class="w100"></adf-dynamic-column>
          </ng-template>
        </data-column>
      </ng-template>
    </ng-container>
  </data-columns>
</adf-datatable>

<mat-chip *ngIf="selection.length > 0" [disableRipple]="true" class="custom-chip" color="accent">Elementos seleccionados
  {{selection.length}}</mat-chip>
